import Box from "@/common/components/Box";
import ResumeItem from "@/common/components/ResumeItem";
import { formatCurrency, formatDecimalUnit, formatDecimalWithGroupedUnit } from "@/common/utils/formatters";
import { CompanyContractConsumptionControlledBy } from "@/features/privateCompanies/types/companyContract.type";
import { ControlledByType, GovernmentAllocationDistributionsLimitsData } from "@/features/privateCompanies/types/companyGovernmentAllocation.type";
import { BoxesIcon, FileBoxIcon } from "lucide-react";
import UpdateDistributionLimit from "./UpdateDistributionLimit";
import DeleteDistributionLimit from "./DeleteDistributionLimit";

interface ProductCategoryDistributionLimitItemProps {
  governmentAllocationId?: string;
  productCategoryDistributionLimit: GovernmentAllocationDistributionsLimitsData['product_category_distribution_limits'][number];
  controlledBy?: ControlledByType;
}

const ProductCategoryDistributionLimitItem = ({
  governmentAllocationId,
  productCategoryDistributionLimit,
  controlledBy,
}: ProductCategoryDistributionLimitItemProps) => {
  const isQuantity = controlledBy === CompanyContractConsumptionControlledBy.Quantity;

  return (
    <Box className="flex flex-col gap-3 p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-2">
            <BoxesIcon strokeWidth={1} />

            <p>{productCategoryDistributionLimit.product_category.display_name}</p>
          </div>
        </div>

        <div className="flex items-center gap-4">
          <UpdateDistributionLimit
            governmentAllocationId={governmentAllocationId}
            productCategoryDistributionLimit={productCategoryDistributionLimit}
            controlledBy={controlledBy}
          />

          <DeleteDistributionLimit
            governmentAllocationId={governmentAllocationId}
            productCategoryDistributionLimitId={productCategoryDistributionLimit.id}
          />
        </div>
      </div>

      <div className="flex">
        <ResumeItem
          label={isQuantity ? "Quantidade máxima" : "Valor máximo"}
          value={isQuantity
            ? formatDecimalWithGroupedUnit(
              Number(productCategoryDistributionLimit.maximum_quantity),
              productCategoryDistributionLimit.product_distribution_limits,
              (p) => p.product.unit_for_quantity,
            )
            : formatCurrency(Number(productCategoryDistributionLimit.maximum_value))
          }
          valueClassName="text-md"
        />
      </div>

      {productCategoryDistributionLimit.product_distribution_limits.map((productDistributionLimit) => (
        <Box className="p-3 flex flex-col gap-3 text-white-400" key={productDistributionLimit.id}>
          <div className="flex items-center justify-between border-s border-blue-800 px-3">
            <div className="flex items-center gap-2">
              <FileBoxIcon strokeWidth={1.5} />

              <p>{productDistributionLimit.product.display_name}</p>
            </div>

            <div className="flex items-end gap-4">

            </div>
          </div>

          <div className="flex">
            <ResumeItem
              label={isQuantity ? "Quantidade máxima" : "Valor máximo"}
              value={isQuantity
                ? formatDecimalUnit(Number(productDistributionLimit.maximum_quantity), productDistributionLimit.product.unit_for_quantity)
                : formatCurrency(Number(productDistributionLimit.maximum_value))
              }
              valueClassName="text-md"
            />
          </div>
        </Box>
      ))}
    </Box>
  );
}

export default ProductCategoryDistributionLimitItem;
